import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { dollars } from 'utils/money';
import { date } from 'utils/date';

const styels = {};

class Quote extends React.Component {
  renderQuote = () => {
    const { quote } = this.props;

    return (
      <div>
        <Typography variant="title" gutterBottom>
          Quote details
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Quote number</TableCell>
              <TableCell>Principal</TableCell>
              <TableCell>Application fee</TableCell>
              <TableCell>Term length</TableCell>
              <TableCell>Drawdown date</TableCell>
              <TableCell>Repayment frequency</TableCell>
              <TableCell>Confirmed at</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                {quote.quoteNumber}
              </TableCell>
              <TableCell>
                {dollars(quote.principal)}
              </TableCell>
              <TableCell>
                {dollars(quote.establishmentFee)}
              </TableCell>
              <TableCell>
                {`${quote.termLength} ${quote.termUnit}`}
              </TableCell>
              <TableCell>
                {date(quote.drawdownDate)}
              </TableCell>
              <TableCell>
                {quote.repaymentFrequency}
              </TableCell>
              <TableCell>
                {date(quote.confirmedAt)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }

  renderSchedule = (schedule) => {
    return (
      <TableRow key={schedule.id}>
        <TableCell>
          {date(schedule.repaymentDatetime)}
        </TableCell>
        <TableCell>
          {schedule.days}
        </TableCell>
        <TableCell>
          {dollars(schedule.principal)}
        </TableCell>
        <TableCell>
          {dollars(schedule.interest)}
        </TableCell>
        <TableCell>
          {dollars(schedule.establishmentFee)}
        </TableCell>
        <TableCell>
          <strong>{dollars(schedule.totalPayable)}</strong>
        </TableCell>
      </TableRow>
    );
  }

  renderSchedules = () => {
    const { quoteSchedules } = this.props.quote;
    return (
      <div>
        <Typography variant="title" gutterBottom>
          Schedule
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Repayment date</TableCell>
              <TableCell>Days</TableCell>
              <TableCell>Principal</TableCell>
              <TableCell>Interest</TableCell>
              <TableCell>Establishment</TableCell>
              <TableCell>Total payable</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {quoteSchedules.map(schedule => this.renderSchedule(schedule))}
          </TableBody>
        </Table>
      </div>
    );
  }

  render = () => {
    return (
      <div>
        {this.renderQuote()}
        <br />
        {this.renderSchedules()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const reduxed = connect(mapStateToProps)(Quote);
export default withStyles(styels)(reduxed);



// WEBPACK FOOTER //
// ./src/components/Loans/Quote.js